import React from "react";
import FirstVerify from "./FirstVerify";
import FirstVerifyIllustration from "./FirstVerifyIllustration";

const FirstVerifyPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row" id="first-verify-page-container">
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 sm:px-12 py-12 lg:py-0" id="first-verify-page-left-section">
        <FirstVerify />
      </div>

      <div className="hidden lg:flex lg:w-1/2 bg-[#E8F0FF] items-center justify-center" id="first-verify-page-right-section">
        <FirstVerifyIllustration />
      </div>
    </div>
  );
};

export default FirstVerifyPage;

